module.exports = __webpack_public_path__ + "assets/images/pages/unleash/unleash-1.webp?134568fe";